// /* eslint-disable react-hooks/rules-of-hooks */
// // src/components/DevTenantSwitcher.tsx
// import React, { Fragment, memo, useEffect, useState } from 'react';

// const TENANTS = [
//   { value: 'NTX', label: 'الحل المتقن' },
//   { value: 'MDHSH', label: 'زهرة المدهش' },
//   { value: 'TESTMDHSH', label: 'TEST MDHSH' },
//   { value: 'ALMAWASEM', label: 'المواسم' },
//   { value: 'FONTE', label: 'مصدر الحياة' }
// ];

// function DevTenantSwitcher() {
//   if (import.meta.env.PROD) return null;

//   const [selectedTenant, setSelectedTenant] = useState(localStorage.getItem('DEV_TENANT_ID') || 'NTX');

//   useEffect(() => {
//     setSelectedTenant(localStorage.getItem('DEV_TENANT_ID') || 'NTX');
//   }, []);

//   const clearDevTenantId = () => {
//     localStorage.removeItem('DEV_TENANT_ID');
//     setSelectedTenant('NTX');
//     window.location.reload();
//   };

//   const setDevTenantId = (tenantId: string) => {
//     localStorage.setItem('DEV_TENANT_ID', tenantId);
//     setSelectedTenant(tenantId);
//     window.location.reload();
//   };

//   // الحصول على اسم العرض للـ tenant المحدد
//   const getSelectedTenantLabel = () => {
//     const tenant = TENANTS.find(t => t.value === selectedTenant);
//     return tenant ? tenant.label : selectedTenant;
//   };

//   return (
//     <Fragment>
//       <div className='menu-item dropdown dropdown-mobile-full'>
//         <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
//           <div className='menu-icon'>
//             <i className='bi bi-code-slash nav-icon'></i>
//           </div>
//           <div className='menu-badge bg-warning'></div>
//         </a>
//         <div className='dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1 text-start'>
//           <h6 className='dropdown-header fs-10px mb-1'>DEV TENANT</h6>
//           <div className='dropdown-divider mt-1'></div>

//           <div className='px-3 py-2'>
//             <div className='mb-3'>
//               <div className='d-flex align-items-center justify-content-between mb-1'>
//                 <div className='text-inverse text-opacity-75'>Current Tenant:</div>
//                 <div className='badge bg-theme'>{getSelectedTenantLabel()}</div>
//               </div>
//               <div className='small text-muted'>
//                 <code className='text-dark'>{selectedTenant}</code>
//               </div>
//             </div>

//             <div className='dropdown-divider my-2'></div>

//             <h6 className='fs-11px mb-2 text-inverse text-opacity-75'>Switch Tenant:</h6>
//             <div className='d-flex flex-column gap-2 mb-3'>
//               {TENANTS.map(tenant => (
//                 <button
//                   key={tenant.value}
//                   className={`btn btn-sm w-100 text-start ${
//                     selectedTenant === tenant.value ? 'btn-theme' : 'btn-outline-default'
//                   }`}
//                   onClick={() => setDevTenantId(tenant.value)}
//                 >
//                   <div className='d-flex align-items-center justify-content-between'>
//                     <div>
//                       <span className='me-2'>{tenant.label}</span>
//                       {tenant.value !== tenant.label && (
//                         <small className='text-muted'>
//                           <code>({tenant.value})</code>
//                         </small>
//                       )}
//                     </div>
//                     {selectedTenant === tenant.value && <i className='bi bi-check-circle-fill'></i>}
//                   </div>
//                 </button>
//               ))}
//             </div>

//             <div className='dropdown-divider my-2'></div>

//             <div className='d-flex justify-content-between'>
//               <button className='btn btn-sm btn-outline-danger' onClick={clearDevTenantId}>
//                 <i className='bi bi-arrow-clockwise me-1'></i>
//                 Reset
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Fragment>
//   );
// }

// export default memo(DevTenantSwitcher);


/* eslint-disable react-hooks/rules-of-hooks */
// src/components/DevTenantSwitcher.tsx
import React, { Fragment, memo, useEffect, useState } from 'react';

const TENANTS = [
  { value: 'NTX', label: 'الحل المتقن' },
  { value: 'MDHSH', label: 'زهرة المدهش' },
  { value: 'MNR', label: 'سلة المنــار' },
  // { value: 'TESTMDHSH', label: 'اختبار المدهش' },
  { value: 'ALMAWASEM', label: 'المواسم' },
  { value: 'FONTE', label: 'مصدر الحياة' }
];

function DevTenantSwitcher() {
  if (import.meta.env.PROD) return null;

  const [selectedTenant, setSelectedTenant] = useState(localStorage.getItem('DEV_TENANT_ID') || 'NTX');

  useEffect(() => {
    setSelectedTenant(localStorage.getItem('DEV_TENANT_ID') || 'NTX');
  }, []);

  const clearDevTenantId = () => {
    localStorage.removeItem('DEV_TENANT_ID');
    setSelectedTenant('NTX');
    window.location.reload();
  };

  const setDevTenantId = (tenantId: string) => {
    localStorage.setItem('DEV_TENANT_ID', tenantId);
    setSelectedTenant(tenantId);
    window.location.reload();
  };

  // الحصول على اسم العرض للـ tenant المحدد
  const getSelectedTenantLabel = () => {
    const tenant = TENANTS.find(t => t.value === selectedTenant);
    return tenant ? tenant.label : selectedTenant;
  };

  return (
    <Fragment>
      <div className='menu-item dropdown dropdown-mobile-full'>
        <a href='#/' data-bs-toggle='dropdown' data-bs-display='static' className='menu-link'>
          <div className='menu-icon'>
            <i className='bi bi-code-slash nav-icon'></i>
          </div>
          <div className='menu-badge bg-warning'></div>
        </a>
        <div className='dropdown-menu dropdown-menu-end mt-1 w-300px fs-11px pt-1 text-start'>
          <h6 className='dropdown-header fs-10px mb-1'>بيئة التطوير</h6>
          <div className='dropdown-divider mt-1'></div>

          <div className='px-3 py-2'>
            <div className='mb-3'>
              <div className='d-flex align-items-center justify-content-between mb-1'>
                <div className='text-inverse text-opacity-75'>البيئة الحالية:</div>
                <div className='badge bg-theme'>{getSelectedTenantLabel()}</div>
              </div>
              <div className='small text-muted text-start'>
                <code className='text-dark'>{selectedTenant}</code>
              </div>
            </div>

            <div className='dropdown-divider my-2'></div>

            <h6 className='fs-11px mb-2 text-inverse text-opacity-75'>تبديل البيئة:</h6>
            <div className='d-flex flex-column gap-2 mb-3'>
              {TENANTS.map(tenant => (
                <button
                  key={tenant.value}
                  className={`btn btn-sm w-100 text-end ${
                    selectedTenant === tenant.value ? 'btn-theme' : 'btn-outline-default'
                  }`}
                  onClick={() => setDevTenantId(tenant.value)}
                >
                  <div className='d-flex align-items-center justify-content-between'>
                    {selectedTenant === tenant.value && <i className='bi bi-check-circle-fill'></i>}
                    <div className='ms-2'>
                      <span className='me-2'>{tenant.label}</span>
                      {tenant.value !== tenant.label && (
                        <small className='text-muted'>
                          <code>({tenant.value})</code>
                        </small>
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <div className='dropdown-divider my-2'></div>

            <div className='d-flex justify-content-between'>
              <button className='btn btn-sm btn-outline-danger' onClick={clearDevTenantId}>
                <i className='bi bi-arrow-clockwise ms-1'></i>
                إعادة تعيين
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default memo(DevTenantSwitcher);